export enum NoAccessReason {
	NO_AUTH = 'no_auth',
	UNKNOWN_PROJECT = 'unknown_project',
	APP_DISABLED = 'app_disabled',
	APP_LOAD_ERROR = 'app_load_error',
	LOADING = 'loading',
	USER_NOT_LOGGED_IN = 'user_not_logged_in',
	TENANT_SELECTION_FAILED = 'tenant_selection_failed',
	NEEDS_TENANT_SELECTION = 'needs_tenant_selection'
}
